import script from "./userLevelOne.vue?vue&type=script&setup=true&lang=js"
export * from "./userLevelOne.vue?vue&type=script&setup=true&lang=js"

import "./userLevelOne.vue?vue&type=style&index=0&id=217aacba&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217aacba"]])

export default __exports__